import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";

import { apiPath } from "../../utility/Constant";

const CareerPage = () => {
  const { careerApi } = apiPath;
  const [clients, clientsLoading] = useFetch(careerApi);

  if (clientsLoading) {
    return <Loading />;
  }

  const { whyJoinUsTitle, careerTitle, careerBg, whyJoinUsdescription } =
    clients;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "careerBg",
      defaultValue: careerBg,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "careerTitle",
      defaultValue: careerTitle,
      required: true,
    },
    {
      elementType: "input",
      label: "Short Description",
      type: "Text",
      name: "whyJoinUsTitle",
      defaultValue: whyJoinUsTitle,
      required: true,
    },
    /* {
      elementType: "textField",
      label: "Join Us description",
      type: "Text",
      name: "whyJoinUsdescription",
      defaultValue: whyJoinUsdescription,
      required: true,
    }, */
  ];

  const update = (data) => {
    updateData(careerApi, data, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CareerPage;
